import { render, staticRenderFns } from "./ProductGroupSidebar.vue?vue&type=template&id=e892669a&"
import script from "./ProductGroupSidebar.vue?vue&type=script&lang=js&"
export * from "./ProductGroupSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e892669a')) {
      api.createRecord('e892669a', component.options)
    } else {
      api.reload('e892669a', component.options)
    }
    module.hot.accept("./ProductGroupSidebar.vue?vue&type=template&id=e892669a&", function () {
      api.rerender('e892669a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/product-group/ProductGroupSidebar.vue"
export default component.exports